import UmedsLogo from '@montugroup/circuit-shared/components/common/UmedsLogo';
import { Box } from '@mui/material';

function NavbarUnauth() {
  return (
    <Box padding="1.5rem">
      <UmedsLogo fillColor={(theme) => theme.palette.primary.main} />
    </Box>
  );
}

export default NavbarUnauth;
